import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const ErrorMessage = styled.div(props => ({
    ...theme(props).typography.smallFont.css(),
    color: theme(props).semanticColors.danger.color,
}));
